import { IIndexable } from 'core-ts-types';
import * as _4 from 'lodash4';

export type t_survey_status = 'NEW' | 'IN_PROGRESS' | 'COMPLETED' | 'DISMISSED' | 'EXPIRED' | null;
export class Survey implements IIndexable {
  id: number;
  nk: string;
  internal_title: string;
  external_title: string;
  mandatory: boolean;
  introduction_text: string;
  informed_consent_text: string;
  completion_text: string;
  welcome_back_text: string;
  status: t_survey_status;
  combined_status: t_survey_status;
  caption: string;
  other_props: object;
  survey: Survey;
  resources: number[];
  _is_survey_in_progress: boolean;
  unavailable_explanation: string;

  constructor(survey: Partial<Survey>) {
    // Survey has 2 statuses, 1 at root level is student status, nested survey has status which reflects publishing status.
    const studentSurveyStatus = survey.combined_status;
    _4.merge(this, survey, survey.survey);
    survey.status = studentSurveyStatus; // reset status as its clobbered.
    this._is_survey_in_progress = studentSurveyStatus === 'IN_PROGRESS';
  }

  static build(survey: Partial<Survey>): Survey {
    return new Survey(survey);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-survey/src/builders/survey_builder.ts